import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../../components";
import { PickUpWhereYouLeftOffInJiraText } from "../../components";

export const LoggedInJiraFreeManagedUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    {team26VisualUpdates ? (
                        <Headings
                            main={<WelcomeBackText />}
                            sub={<PickUpWhereYouLeftOffInJiraText />}
                        />
                    ) : (
                        <>
                            <h1 css={headerCss}>
                                <WelcomeBackHeading />
                            </h1>
                            <p css={subHeaderCss}>
                                <PickUpWhereYouLeftOffInJiraText />
                            </p>
                        </>
                    )}
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    marginBlockStart: 4,
    marginBlockEnd: 16,
    textAlign: "center"
});
